import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Breadcrumb from './components/Breadcrumb';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import CustomRequest from './pages/CustomRequest';
import Login from './pages/Login';
import AdminPanel from './admin/AdminPanel';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import './App.css';
import Auction from './pages/Auction';
import PaintingDetails from './pages/PaintingDetails';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <a href="#main-content" className="skip-link">Skip to main content</a>
          <header>
            <Navbar />
            <Breadcrumb />
          </header>
          <main id="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/painting/:slug" element={<PaintingDetails />} />
              <Route path="/auctions" element={<Auction />} />
              <Route path="/custom-request" element={<CustomRequest />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/login" element={<Login />} />
              <Route path="/super-adminp" element={<AdminPanel />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Canvaart</h3>
            <p>Bringing imagination to life through colors and canvas.</p>
            <p>Original paintings by Aanishka Chowdhury</p>
          </div>
          <div className="footer-section">
            <h4>Explore</h4>
            <nav aria-label="Footer navigation">
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/gallery">Gallery</a></li>
                <li><a href="/auctions">Auctions</a></li>
                <li><a href="/custom-request">Custom Request</a></li>
                <li><a href="/blog">Art Blog</a></li>
                <li><a href="/about">About the Artist</a></li>
                <li><a href="/faq">FAQ</a></li>
              </ul>
            </nav>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: help@canvaart.com</p>
            <p>Phone: +91 9933558299</p>
            <p>India</p>
          </div>
          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="https://instagram.com/canvaart" target="_blank" rel="noopener noreferrer" aria-label="Follow Canvaart on Instagram">Instagram</a>
              <a href="https://facebook.com/canvaart" target="_blank" rel="noopener noreferrer" aria-label="Follow Canvaart on Facebook">Facebook</a>
              <a href="https://twitter.com/canvaart" target="_blank" rel="noopener noreferrer" aria-label="Follow Canvaart on Twitter">Twitter</a>
              <a href="https://pinterest.com/canvaart" target="_blank" rel="noopener noreferrer" aria-label="Follow Canvaart on Pinterest">Pinterest</a>
              <a href="https://youtube.com/canvaart" target="_blank" rel="noopener noreferrer" aria-label="Follow Canvaart on YouTube">YouTube</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Canvaart. All rights reserved.</p>
          <nav aria-label="Legal links" className="footer-legal">
            <a href="/faq">FAQ</a>
            <span className="separator">|</span>
            <a href="/about">About</a>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default App;
